import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {ArrowButtonDirection, ArrowButtonSize} from './ArrowButton.enum';
import {ArrowButtonProps} from './ArrowButtonProps.interface';

export function ArrowButton({
  direction,
  size,
  className,
  onClick,
  ...props
}: ArrowButtonProps) {
  return (
    <div
      className={twMerge(
        'flex cursor-pointer items-center justify-center rounded-full bg-static-mono-black opacity-80',
        ARROW_BUTTON_SIZE[size],
        size === ArrowButtonSize.Large &&
          LARGE_ARROW_BUTTON_POSITION[direction],
        size === ArrowButtonSize.Small &&
          SMALL_ARROW_BUTTON_POSITION[direction],
        className
      )}
      onClick={onClick}
      {...props}
    >
      <div className="relative flex h-full w-full items-center justify-center">
        <Icon
          type={
            direction === ArrowButtonDirection.Right
              ? IconType.ButtonArrowRightLStatic
              : IconType.ButtonArrowLeftLStatic
          }
        />
        <div
          className={twMerge(
            ARROW_BUTTON_SIZE[size],
            'absolute rounded-full border-1 border-solid border-static-mono-white opacity-20'
          )}
        />
      </div>
    </div>
  );
}

const ARROW_BUTTON_SIZE = {
  [ArrowButtonSize.Large]: 'w-44pxr h-44pxr',
  [ArrowButtonSize.Small]: 'w-36pxr h-36pxr',
};

const LARGE_ARROW_BUTTON_POSITION = {
  [ArrowButtonDirection.Right]: 'right-33pxr',
  [ArrowButtonDirection.Left]: 'left-33pxr',
};

const SMALL_ARROW_BUTTON_POSITION = {
  [ArrowButtonDirection.Right]: 'right-24pxr',
  [ArrowButtonDirection.Left]: 'left-24pxr',
};
